module.exports = __webpack_public_path__ + "img/00012.2af1ffbe.webp";